<div class="modalPayment vc-modal__innerContainer">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <vc-sprite-icons class="vc-modal__closeBtn__cross" name="cross-x-thick"></vc-sprite-icons>
  </button>

  <!-- ONEY -->
  <div *ngIf="paymentName === 'facilypay_oney'" class="modalPaymentContainer">
    <vc-modal-facilipay-oney></vc-modal-facilipay-oney>
  </div>

  <!-- SPLIT IT -->
  <div *ngIf="paymentName === 'splitit'" class="modalPaymentContainer modalPaymentContainer--splitit vc-body3">
    <div class="modalPayment__title vc-modal__title" i18n="@@MODAL_PAYMENT.SPLITIT.TITLE">
      INTEREST FREE PAYMENT PLAN
    </div>
    <p class="modalPayment__intro" i18n="@@MODAL_PAYMENT.SPLITIT.INTRO">
      Pay in interest free instalments with Splitit using your Mastercard and Visa credit cards (no debit cards).
      Available on all UK orders made in GBP.
    </p>
    <ul class="modalPayment__list">
      <li class="modalPayment__item">
        <vc-sprite-icons
          name="clock"
          class="modalPayment__item__icon modalPayment__item__icon--clock"
        ></vc-sprite-icons>
        <div class="modalPayment__item__text">
          <p class="modalPayment__item__text__title" i18n="@@MODAL_PAYMENT.SPLITIT.QUICK_EASY_TITLE">Quick and Easy</p>
          <p class="modalPayment__item__text__paragraph" i18n="@@MODAL_PAYMENT.SPLITIT.QUICK_EASY_PARAGRAPH">
            No credit checks, no paperwork, only fill in your card details
          </p>
        </div>
      </li>
      <li class="modalPayment__item">
        <img class="modalPayment__item__icon modalPayment__item__icon--coins" src="/assets/svg/coins.svg" alt="" />
        <div class="modalPayment__item__text">
          <p class="modalPayment__item__text__title" i18n="@@MODAL_PAYMENT.SPLITIT.INTEREST_TITLE">Interest-free</p>
          <p class="modalPayment__item__text__paragraph" i18n="@@MODAL_PAYMENT.SPLITIT.INTEREST_PARAGRAPH">
            Splitit and Vestiaire will not charge any interest
          </p>
        </div>
      </li>
    </ul>
    <div class="modalPayment__note">
      <div class="modalPayment__note__title" i18n="@@MODAL_PAYMENT.SPLITIT.NOTE_TITLE">IMPORTANT NOTE:</div>
      <p class="modalPayment__note__text" i18n="@@MODAL_PAYMENT.SPLITIT.NOTE_PARAGRAPH">
        1. A PAYMENT AUTHORISATION FOR THE OUTSTANDING AMOUNT OF YOUR PURCHASE WILL BE HELD DURING THE FULL PLAN PERIOD
        as security. This hold will be charged ONLY in the event a monthly payment is declined (the authorisation hold
        might appear as "Pending" on your credit card bill). <br />
        2. You must maintain a sufficient "Required Available Credit" amount on your credit card for both the full
        outstanding amount of your purchase and the monthly payment during the full period of the plan. <br />
        3. Your credit card issuer may charge you interest on amounts charged to your credit card unless you pay Your
        credit card balance in full each month. <br />
        4. In case we do not manage to reauthorize the remaining amount of the transaction, you will receive a notice
        email. In that case, you will have to promptly update your credit card details. In case your bank still refuses
        to reauthorize the outstanding amount, we will have to charge the full outstanding amount of the transaction at
        once from your credit card.
      </p>
    </div>
    <p class="modalPayment__tips">
      <ng-container i18n="@@MODAL_PAYMENT.SPLITIT.TIPS.TEXT">
        Any questions? Find out more about
      </ng-container>
      <img class="modalPayment__tips__logo" src="assets/svg/carts/splitit.svg" />
      <vc-ref
        [resource]="'https://www.vestiairecollective.com/financing-splitit.shtml'"
        [anchor]="true"
        [blank]="true"
        class="modalPayment__tips__link"
        i18n="@@MODAL_PAYMENT.SPLITIT.TIPS.LINK_TEXT"
      >
        here.
      </vc-ref>
    </p>
  </div>

  <!-- KLARNA -->
  <div *ngIf="paymentName === 'klarna'" class="modalPaymentContainer modalPaymentContainer--klarna vc-body3">
    <div class="modalPayment__title vc-modal__title" i18n="@@MODAL_PAYMENT.KLARNA.TITLE">How does Klarna Work?</div>
    <p class="modalPayment__intro" i18n="@@MODAL_PAYMENT.KLARNA.INTRO">
      With Klarna, you can either pay against invoice or by monthly instalments!
    </p>
    <ul class="modalPayment__list">
      <li class="modalPayment__item">
        <img
          class="modalPayment__item__icon modalPayment__item__icon--calendar"
          src="/assets/svg/calendar.svg"
          alt=""
        />
        <div class="modalPayment__item__text">
          <p class="modalPayment__item__text__paragraph" i18n="@@MODAL_PAYMENT.KLARNA.DELIVERY_PARAGRAPH">
            Order now and then have 14 days to pay from the day the product is quality checked.
          </p>
        </div>
      </li>
      <li class="modalPayment__item">
        <img
          class="modalPayment__item__icon modalPayment__item__icon--banknote"
          src="/assets/svg/banknote.svg"
          alt=""
        />
        <div class="modalPayment__item__text">
          <p class="modalPayment__item__text__paragraph" i18n="@@MODAL_PAYMENT.KLARNA.PAYMENT_PARAGRAPH">
            Order now then pay in instalments, as agreed with Klarna. Your products are always delivered to your home
            before you have to pay, and all purchases are gathered together in a single monthly invoice. Please note
            that the minimum monthly payment for combined or single purchases is 1/24 of the total amount due. However,
            a minimum payment of €6.95 always applies.
          </p>
        </div>
      </li>
    </ul>
    <p class="modalPayment__tips">
      <ng-container i18n="@@MODAL_PAYMENT.KLARNA.TIPS.TEXT"
        >Any other questions? You can find out more about Klarna</ng-container
      >&nbsp;<vc-ref
        [resource]="'https://www.vestiairecollective.com//klarna/'"
        [anchor]="true"
        [blank]="true"
        class="modalPayment__tips__link"
        i18n="@@MODAL_PAYMENT.KLARNA.TIPS.LINK_TEXT"
        >here.</vc-ref
      >
    </p>
  </div>
</div>
